import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Day, Month, Year } from './BirthdayPicker';
import { T, TraksConsumer } from '../traks';
import { site_name } from '../Site';

const BirthdaySelector = (props) => {
	return (
		<div>
			<span className="ad_little_larger_txt"><b><T>Year of birth (e.g. 1997):</T></b></span>&nbsp;<div className="d-flex pb-3"><img src="/gfx/direction-right-icon-0.svg" style={{width: "24px"}} alt="arrow"/>&nbsp;<Year className={props.className} value={props.y} set={props.set_y}/></div>
			<div className="ad_little_larger_txt pb-3"><b><T>Month:</T></b><TraksConsumer><Month className={props.className} value={props.m} set={props.set_m}/></TraksConsumer></div>
			<span className="ad_little_larger_txt"><b><T>Day:</T></b></span><TraksConsumer><Day className={props.className} value={props.d} set={props.set_d}/></TraksConsumer>
		</div>
	);
}

const AgeControl = (props) => {
	const [ y, set_y ] = useState("");
	const [ m, set_m ] = useState("");
	const [ d, set_d ] = useState("");
	const [ disabled, set_disabled ] = useState(true);

	const check_year = () => {
		const today = new Date();
		const today_year = today.getFullYear();
		const year = parseInt(y, 10);

		if ((today_year-150) <= year && year <= (today_year-5))
			return true;

		return false;
	}

	useEffect(() => {
		if(check_year() && m.length && d.length) set_disabled(false);
	}, [y, m, d]);

	const set_bday = () => {
		const mm = parseInt(m, 10) + 1;
		const bday = y + "-" + (mm < 10 ? '0' + mm : mm) + "-" + (d < 10 ? '0' + d : d);

		props.set_birthday(bday);
	}

	return (
		<Container className='pb-5'>
			<Row className="pt-4 pb-2 px-0">
				<Col xs="12">
					<div className='ad_game_box'>
						<div className='text-center pt-2 pt-lg-4'>
							<img alt='birthday' src='/gfx/bday-cake-icon-0.svg' />
						</div>
						<h1 className='text-center'>
							<T>Age check</T>
						</h1>
						<div className='p-2 p-md-4'>
							<T>
							In order to comply with Danish law, we need to know your age.<br />
							This is <i>only</i> used to determine what content can be shown on {site_name}, and will <i>never</i> be
							shared with anyone, except with your explicit consent.
							</T>
						</div>
						<div className='p-2 p-md-4'>
							<BirthdaySelector className="form-control" y={y} m={m} d={d} set_y={set_y} set_m={set_m} set_d={set_d} />
						</div>
						<div className='text-center text-md-left pt-2 px-2 px-md-4 pb-4'>
							<Button disabled={disabled} onClick={set_bday} className="ad_new_game_button ad_rbtn_25px py-2 px-5"><T>Save birthdate</T></Button>
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
}

export default AgeControl;



// WEBPACK FOOTER //
// ./src/c/AgeControl.js